var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGravynLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 652,
    height: 652,
    viewBox: "0 0 652 652",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.649 10.0459C347.33 -11.7841 455.951 7.09724 561.744 18.46L435.063 123.212C435.063 123.212 385.282 113.247 353.14 113.754C321.303 114.256 294.982 119.547 272.549 125.569C162.37 155.144 96.9839 268.596 126.506 378.969C156.028 489.344 269.28 554.845 379.46 525.27C558.032 477.336 559.491 265.194 494.991 297.138L228.342 433.373L579.008 129.977C579.008 129.977 589.918 139.641 596.037 146.668C603.78 155.562 613.489 171.308 613.585 171.463L613.515 171.525C624.994 193.092 634.228 216.298 640.813 240.919C687.401 415.091 584.226 594.123 410.36 640.794C236.493 687.464 57.7735 584.098 11.1859 409.924C-35.4011 235.75 67.7822 56.7156 241.649 10.0459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGravynLogo);
export default __webpack_public_path__ + "static/media/gravyn_logo.6669582547228901cf322eba064983aa.svg";
export { ForwardRef as ReactComponent };